import { render } from "./SanMutation.vue?vue&type=template&id=3a20643c&scoped=true"
import script from "./SanMutation.vue?vue&type=script&lang=js"
export * from "./SanMutation.vue?vue&type=script&lang=js"

import "./SanMutation.vue?vue&type=style&index=0&id=3a20643c&scoped=true&lang=css"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a20643c"]])

export default __exports__